import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const RETsExportRequest = (values, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RanReportKpis/RETsExport`,
	data: { values, userId }
});

export const RETEntireNetworkspExportRequest = (userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RanReportKpis/RETEntireNetworkspExport`,
	data: { userId }
});

export const GetRETFilesHistory = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RanReportKpis/GetRETFilesHistory`,
});
